<template>
  <AccordionSkeleton v-if="status === 'pending' || status === 'idle'">
    <slot name="icon" />
  </AccordionSkeleton>

  <RevAccordionItem v-else>
    <template #prefix>
      <slot name="icon" />
    </template>
    <template #title>
      <slot name="title" />
    </template>
    <template #description>
      <span v-if="status === 'error'">
        {{ errorDescription }}
      </span>
      <slot v-else name="description" />
    </template>
    <template #body>
      <ErrorInfoBlock v-if="status === 'error'" @try-again="onRefresh" />
      <slot v-else name="body" />
    </template>
  </RevAccordionItem>
</template>

<script setup lang="ts">
import { RevAccordionItem } from '@ds/components/AccordionItem'

import ErrorInfoBlock from '~/scopes/customer-care/components/ErrorInfoBlock/ErrorInfoBlock.vue'

import AccordionSkeleton from '../AccordionSkeleton/AccordionSkeleton.vue'

interface Props {
  status: 'pending' | 'idle' | 'success' | 'error'
  errorDescription: string
}

interface Emits {
  (e: 'refresh'): void
}

defineProps<Props>()

const emit = defineEmits<Emits>()

const onRefresh = () => {
  emit('refresh')
}
</script>
